import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {IDealsStore} from "../../mobx-store/storeInterfaces/dealsStoreInterface";
import {TableCellTypes} from "../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes";
import {RouteComponentProps} from "react-router";
import GeneralTableComponent from "../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent";

interface IProps extends RouteComponentProps {
    dealsStore: IDealsStore;
}


@inject('dealsStore')
@observer
class DealsScreen extends Component<IProps> {
    addButton: any;
    tableHeader: any = [];
    tableData: any[] = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string;

    constructor(props: IProps) {
        super(props);
        this.title = 'Manage Deals';
    }

    handleTableButtonCellClicked = (index: string, key: string) => {
        this.props.history.push(`/deals/${index}/${key}`);
    };

    handelAdd = (): void => {
        this.props.history.push('/deals/new');
    };

    getAddAdButton = () => {
        return {
            title: 'Add Deal',
            onAdd: this.handelAdd,
        };
    };

    getAdsTableHeader = () => {
        return [
            {
                title: 'Deal Name',
            },
            {
                title: 'Deal Image',
            },
            {
                title: 'Deal Discount',
            },
            {
                title: 'Edit',
            }
        ];
    };


    getAdsTableCellTypes = (): TableCellTypes[] => {
        return [
            {
                cellType: 'Text',
                key: 'name',
            },
            {
                cellType: 'Image',
                key: 'image',
            },
            {
                cellType: 'Text',
                key: 'discount',
            },
            {
                cellType: 'Button',
                key: 'edit',
                onClick: this.handleTableButtonCellClicked
            }
        ];
    };

    componentDidMount(): void {
        this.props.dealsStore.getDeals();
    }

    render() {
        const {loaded, categories: oCategories, items: oItems, deals: oDeals} = this.props.dealsStore;
        if (loaded) {
            const categoriesDeals = oDeals.map(d => {
                const category = oCategories.filter(oCat => oCat.categoryId === d.category);
                const item = oItems.filter(oItem => oItem.itemId === d.item);
                return {
                    ...d,
                    category: category ? category : undefined,
                    item: item ? item : undefined,
                    edit: 'Edit',
                    id: d.dealId,
                    discount: (d.discount || 0).toString() + '%'
                }
            });
            this.addButton = this.getAddAdButton();
            this.tableHeader = this.getAdsTableHeader();
            this.tableData = categoriesDeals;
            this.tableCellTypes = this.getAdsTableCellTypes();
            return loaded && (
                <div>
                    <GeneralTableComponent emptyMessage='There are no deals added yet'
                                           title={this.title}
                                           tableHeader={this.tableHeader}
                                           tableData={this.tableData}
                                           tableCellTypes={this.tableCellTypes}
                                           addButton={this.addButton}/>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default DealsScreen;

